/**
 * Environment-related utility functions
 */

/**
 * Checks if the current environment is localhost
 * @returns {boolean} True if running on localhost, false otherwise
 */
export function isLocalhost() {
  return (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  );
}
